var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-question';
                    var viewUrl = 'sprite.svg#view-icon-question';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 302.967 302.967',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };